<template>
  <atomic-link class="play-bingo" @click="handleClick">
    <div class="play-bingo__progress-circle">
      <div class="play-bingo__progress-ring"></div>
      <div class="play-bingo__progress-text" v-if="!isDrawerCompact">5/20</div>
      <atomic-image :src="`${gamehubCdn}/images/coinsbox-small.png`" v-else :width="24" :height="24" />
    </div>

    <div class="play-bingo__content" v-if="!isDrawerCompact">
      <div class="play-bingo__content-text">
        {{ getContent(layoutData, defaultLocaleLayoutData, 'siteSidebar.playBetaBingo') }}
      </div>
      <div class="play-bingo__content-reward">
        <atomic-image :src="`${gamehubCdn}/images/coinsbox-small.png`" :width="24" :height="24"/>
        <span class="play-bingo__reward-text">10 FS</span>
      </div>
    </div>

  </atomic-link>
</template>

<script setup lang="ts">
  const globalStore = useGlobalStore();
  const { layoutData, defaultLocaleLayoutData } = storeToRefs(globalStore);
  const { getContent } = useProjectMethods();

  const layoutStore = useLayoutStore();
  const { isDrawerCompact } = storeToRefs(layoutStore);

  const handleClick = (): void => {

  };

  const {
    public: { gamehubCdn },
  } = useRuntimeConfig();
</script>

<style src="~/assets/styles/components/atomic/menu/play-bingo.scss" lang="scss" />
